import type { SqliteStatementResult, SqlParam } from './sqliteDatabase'

const WAL_CHECKPOINT_PRAGMA =
    /^\s*PRAGMA\s+(?:(?:main|temp)\s*\.\s*)?wal_checkpoint\s*(?:\(\s*(?:PASSIVE|FULL|RESTART|TRUNCATE)?\s*\)|=\s*(?:PASSIVE|FULL|RESTART|TRUNCATE))?\s*;?\s*$/i

export function isManagedWalCheckpointPragma(sql: string, params?: readonly SqlParam[]): boolean {
    return (!params || params.length === 0) && WAL_CHECKPOINT_PRAGMA.test(sql)
}

export function createManagedWalCheckpointResult<T = Record<string, unknown>>(
    sql: string,
    params?: readonly SqlParam[],
): SqliteStatementResult<T> | null {
    if (!isManagedWalCheckpointPragma(sql, params)) {
        return null
    }

    return {
        rows: [{ busy: 0, log: 0, checkpointed: 0 }] as T[],
        changes: 0,
        lastInsertRowId: 0n,
    }
}
